import ColorsMixin from '@/mixins/colors.mixin';
export default {
  name: 'TwinMapMarkerColorPickerMenu',
  mixins: [ColorsMixin],
  props: {
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      colorPickerMenu: false,
      menuX: 0,
      menuY: 0
    };
  },
  computed: {
    colorForActivator() {
      return this.value || this.colors[0].value;
    }
  },
  methods: {
    openMenu(e) {
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.colorPickerMenu = true;
    }
  }
};